<div class="dialog">
  <div class="dialog__header">
    <h1 class="dialog__title">セミナー日程紐付け</h1>
    <span class="close" (click)="close()"></span>
  </div>
  <div class="dialog__body">
    <p class="dialog__message">下記の日程をセミナー日程に紐付けますか？</p>
    <p class="dialog__date">
      開催日付：
      {{ config.data.schedules[0].startAt | safeDate: "yyyy/MM/dd(E)" }}
    </p>
    <table class="schedule-table">
      <thead>
        <tr>
          <th></th>
          <th class="schedule-table__datetime">開始~終了</th>
          <th>現在数</th>
          <th>動員枠</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let schedule of config.data.schedules">
          <td>
            <input
              type="radio"
              name="seminar-schedule"
              [value]="schedule.id"
              [disabled]="isSingleSchedule"
              [(ngModel)]="selectedScheduleId"
            />
          </td>
          <td class="schedule-table__datetime">
            {{ schedule.startAt | safeDate: "HH:mm" }}
            <span *ngIf="schedule.endAt">
              ~ {{ schedule.endAt | safeDate: "HH:mm" }}
            </span>
          </td>
          <td>{{ schedule.reservationCount || 0 }}</td>
          <td>{{ schedule.capacity }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="dialog__footer">
    <button class="dialog__button dialog__button--accent" (click)="close()">
      キャンセル
    </button>
    <button
      class="dialog__button dialog__button--primary"
      [disabled]="!canSubmit"
      (click)="submit()"
    >
      OK
    </button>
  </div>
</div>
